var TextArea = require('./textArea'),
    _ = require('underscore');


module.exports = TextArea.extend({

    initialize: function() {

        this.pgLevelWordIds = [];
        this.docLevelWordIds = [];

        TextArea.prototype.initialize.apply( this, arguments );

    },

    defaults: _.extend( {}, TextArea.prototype.defaults, {

        pageLevelZoneId: null,
        pageLevelZoneLineId: null, // maybe just call index ?

        // TODO: see if these help with any positioning
        baseline: null,
        fontsize: null

    }),

    parse: function(attrs, options) {

        var baseAttrs = TextArea.prototype.parse.apply(this, arguments);

        baseAttrs.pageLevelZoneId = options.pageLevelZoneId;
        baseAttrs.pageLevelZoneLineId = options.pageLevelZoneLineId;

        baseAttrs.baseline = attrs.baseline;
        baseAttrs.fontsize = attrs.fontsize;

        return baseAttrs;

    },

    _generatePageKeyId: function(options) {
        return options.pageNumber + '_' + options.pageLevelZoneId + '_' + options.page_level_id;
    },

    addPageLevelWordId: function( pgLevelWordId ) {

        this.pgLevelWordIds.push( pgLevelWordId );

    },

    addDocLevelWordId: function( docLevelWordId ) {

        this.docLevelWordIds.push( docLevelWordId );
    },

    getPageLevelWordIds: function() {
        return this.pgLevelWordIds;
    },

    getDocLevelWordIds: function() {
        return this.docLevelWordIds;
    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/positionalTextModels/textAreaModels/line.js
 ** module id = 352
 ** module chunks = 0
 **/